import { v4 as uuidv4 } from 'uuid'

import { createNameFromCustomAudiences } from '../../../../../Multiplatform/LineItemForms/formatters'
import { formatTargetingToBE } from './formatTargetingToBE'
import { formatUnitType } from './formatUnitType'
import {
  getAllocationInfo,
  getIsBudgetAllocationType
} from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { calc } from '../../../../../../helpers/numbers'
import { formatStartDateForGAM } from './datesFormatters'
import { formatEndDate } from '../../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/formatters'

import {
  MAX_IMPRESSIONS,
  TIME_UNIT,
  TIME_UNIT_COUNT,
  timeUnits
} from '../Steps/DatesStep/AdvancedSettings/FrequencyCapSection/fields'
import { LABELS } from '../../reusableFields/fields'
import { END_DATE, START_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import {
  AUDIENCE_SEGMENTS,
  ENVIRONMENT_TYPE,
  environmentTypes,
  LINE_ITEM_TYPE,
  // roadblockingTypes,
  lineItemTypes,
  skippableAdTypes
} from '../fields'

const formatBudgetToUnits = (budget = 0, microAmount = 0) => {
  // Round result to the nearest whole number since GAM requires units to be an integer
  return calc(budget).div(microAmount).mul(1000).ceil().toNumber()
}

const formatCostType = billingEvent => {
  const costTypeEnums = {
    cpm: 'CPM',
    cpc: 'CPC',
    viewable_cpm: 'VCPM'
  }

  return costTypeEnums[billingEvent]
}

export const formatUnitsToBudget = (units = 0, microAmount = 0) => {
  return calc(units).mul(microAmount).div(1000).toNumber()
}

export const transformLineItemToBE = ({ inventory, units, microAmount, values, campaignId, right, currency }) => {
  const billingEvent = right.billing_event

  // Determine line item type based on allocation type (percentage vs quantity)
  const { isPercentageAllocation } = getAllocationInfo(right)
  const gamLineItemType = isPercentageAllocation ? lineItemTypes.SPONSORSHIP : lineItemTypes.STANDARD

  // Determine skippable ad type based on advanced settings
  const skippableAdsEnabled = right.advanced_settings?.skippable_ads_enabled || false
  const skippableAdType = skippableAdsEnabled ? skippableAdTypes.ENABLED : skippableAdTypes.DISABLED

  const isBudgetAllocationType = getIsBudgetAllocationType(right)

  return {
    name: `${createNameFromCustomAudiences(values[AUDIENCE_SEGMENTS])} - ${uuidv4().slice(0, 7)}`,
    date_start: formatStartDateForGAM(values[START_DATE]),
    date_stop: formatEndDate(values[END_DATE]),
    order_id: campaignId,
    creative_rotation_type: 'OPTIMIZED',
    [LINE_ITEM_TYPE]: gamLineItemType,
    [ENVIRONMENT_TYPE]: values[ENVIRONMENT_TYPE],
    skippable_ad_type: skippableAdType,
    // ...(values[ENVIRONMENT_TYPE] === environmentTypes.VIDEO_PLAYER ? {} : { roadblocking_type: roadblockingTypes.CREATIVE_SET }), // todo PBR-1311 currently this part of payload fails, uncomment when resolve
    discount: 0,
    cost_per_unit: {
      currency_code: currency,
      micro_amount: microAmount
    },
    cost_type: formatCostType(billingEvent),
    primary_goal: {
      goal_type: isPercentageAllocation ? 'UNKNOWN' : 'LIFETIME',
      unit_type: formatUnitType(billingEvent),
      units: isBudgetAllocationType ? formatBudgetToUnits(units, microAmount) : units
    },
    companion_delivery_option: 'OPTIONAL',
    creative_placeholders: [
      {
        size: {
          width: '300',
          height: '250'
        }
      }
    ],

    ...(values[MAX_IMPRESSIONS] &&
      values[MAX_IMPRESSIONS].trim() !== '' && {
        // Only include frequency_caps when MAX_IMPRESSIONS is filled
        frequency_caps: [
          {
            [MAX_IMPRESSIONS]: values[MAX_IMPRESSIONS],
            [TIME_UNIT]: values[TIME_UNIT],
            ...(values[TIME_UNIT] !== timeUnits.LIFETIME && {
              [TIME_UNIT_COUNT]: values[TIME_UNIT_COUNT]
            })
          }
        ]
      }),
    ...(values[LABELS].length && {
      [LABELS]: values[LABELS].map(label => ({
        labelId: label.id
      }))
    }),

    targeting: formatTargetingToBE({ inventory, values, right }),

    ...(values[ENVIRONMENT_TYPE] === environmentTypes.VIDEO_PLAYER && {
      video_max_duration: '300000'
    })
  }
}
